import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { topStoriesNewsRoutes } from  '../../../common/translation/translate.js';
import { LifeSubStory } from './lifeSubStory';
import { DisplayAdWidget } from '../../ads/displayAdWidget.jsx';
import { DisplayAdUnit } from '../../../containers/ads/displayAdUnitContainer';

export const LifeStories  = memo(({ mainStory, subStoriesList=[], slotId, isMobile, enableSourceParameterOnStoriesLinks, source }) => {
    const subStories = subStoriesList.slice(1, subStoriesList.length);

    let mainStoryHref = `${topStoriesNewsRoutes.news}${mainStory?.NodeAlias}`;
    if (enableSourceParameterOnStoriesLinks) {
        mainStoryHref = `${location.origin}/${mainStoryHref}?source=${source}`;
    }

    return (
        <Container>
            {enableSourceParameterOnStoriesLinks 
                ? <Anchor href={mainStoryHref} target='_self'>
                    <FeaturedStoryTitle>{mainStory?.Title}</FeaturedStoryTitle>
                    <FeaturedStoryCard
                        imageLink={mainStory?.ImageLink}
                        title={mainStory?.ImageCaption}
                    />
                </Anchor>
                : <Anchor href={mainStoryHref}>
                    <FeaturedStoryTitle>{mainStory?.Title}</FeaturedStoryTitle>
                    <FeaturedStoryCard
                        imageLink={mainStory?.ImageLink}
                        title={mainStory?.ImageCaption}
                    />
                </Anchor>
            }
            <SubStoryCardList>
                {subStories.map((subStory, i) => {
                    return (
                        <React.Fragment key={subStory.Id}>
                            <LifeSubStory
                                key={subStory.Id}
                                subStory={subStory}
                                enableSourceParameterOnStoriesLinks={enableSourceParameterOnStoriesLinks}
                                source={source}
                            />
                            {i === 1 && isMobile && <AdWrapper>
                                <DisplayAdUnit 
                                    slotId={slotId}
                                    height={250}
                                    width={300}
                                />
                            </AdWrapper>}
                        </React.Fragment>
                    );
                })}
            </SubStoryCardList>
        </Container>
    );
});

LifeStories.displayName = 'LifeStories';
LifeStories.propTypes = {
    mainStory: PropTypes.object,
    subStoriesList: PropTypes.array
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
`;

const Anchor = styled.a`
    text-decoration: none;
    display: block;
`;

const FeaturedStoryTitle = styled.div`
    border-radius: 2px 2px 0 0;
    padding: 10px 16px;
    margin-top: 12px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    color: #455560;
    background-color: white;
    white-space: normal;
`;

const FeaturedStoryCard = styled.div`
    background-image: ${({ imageLink }) =>
        imageLink ? 'url(' + imageLink + ')' : ''};
    border-radius: 0 0 2px 2px;
    background-color: #000000;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 300px;
`;

const SubStoryCardList = styled.ul`
    padding-left: 0;
    margin-right: -10px;
    white-space: normal;

    @media ${mediumMediaQuery} {
        margin: 0 -9px 0 1px;
    }

    @media ${smallMediaQuery} {
        margin: 2px 0 4px 0;
    }
`;

const AdWrapper = styled.div`
    margin-top: 10px;
`;
